import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Book, Gauge, Users } from "lucide-react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const dashHref = user?.role === "leader" ? "/leader" : "/dashboard";

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-3">
        <Link to={user ? dashHref : "/"} data-testid="header-logo-link">
          <Logo />
        </Link>
        <nav className="flex items-center gap-2 sm:gap-6">
          {user && (
            <>
              <Link
                to={dashHref}
                data-testid="nav-dashboard-link"
                className={`hidden sm:flex items-center gap-2 text-sm transition-colors ${
                  pathname === dashHref ? "text-gold" : "text-slate-400 hover:text-white"
                }`}
              >
                {user.role === "leader" ? <Users size={16} /> : <Gauge size={16} />}
                {user.role === "leader" ? "Team" : "Dashboard"}
              </Link>
              <Link
                to="/knowledge"
                data-testid="nav-knowledge-link"
                className={`flex items-center gap-2 text-sm transition-colors ${
                  pathname === "/knowledge" ? "text-gold" : "text-slate-400 hover:text-white"
                }`}
              >
                <Book size={16} />
                <span className="hidden sm:inline">Knowledge</span>
              </Link>
              <div className="hidden md:flex items-center gap-3 pl-4 ml-2 border-l border-white/10">
                <div className="text-right leading-tight">
                  <div className="text-sm text-white font-medium">{user.full_name}</div>
                  <div className="hud-label text-[9px]">
                    {user.role === "leader" ? "Lead Pilot" : "Recruit"}
                  </div>
                </div>
                <button
                  onClick={handleLogout}
                  data-testid="header-logout-button"
                  className="text-slate-400 hover:text-[#F43F5E] transition-colors p-2"
                  aria-label="Logout"
                >
                  <LogOut size={16} />
                </button>
              </div>
              <button
                onClick={handleLogout}
                data-testid="header-logout-button-mobile"
                className="md:hidden text-slate-400 hover:text-[#F43F5E] p-2"
                aria-label="Logout"
              >
                <LogOut size={16} />
              </button>
            </>
          )}
          {!user && (
            <Link
              to="/login"
              data-testid="header-login-link"
              className="text-sm text-slate-300 hover:text-gold transition-colors"
            >
              Sign In
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
